export default "__VITE_ASSET__BIL8WYAm__ 400w, __VITE_ASSET__BArxBSj9__ 800w, __VITE_ASSET__D5x72gNk__ 1024w";